import React from "react";
import { Select } from "antd";
const SelectOption = ({
  options,
  placeholder,
  defaultValue,
  onChange,
  ...props
}) => (
  <Select
    allowClear
    placeholder={placeholder}
    options={options}
    defaultValue={defaultValue}
    onChange={onChange}
    style={{ minWidth: "250px" }}
    {...props}
  />
);
export default SelectOption;
